import qs from 'query-string';
import { useAuthFetch } from '@cko/dashboard-shared';
import { QueryFunction } from '@tanstack/react-query';

import { ProcessingChannelsResponseBody } from './types';

export type UseProcessingChannelsQueryKey = [
  string,
  {
    clientId: string;
    entityId?: string;
  },
];

export type Params = {
  clientId: string;
  entityId?: string | null;
};

export const useProcessingChannelsFetcher = () => {
  const fetch = useAuthFetch();

  const processingChannelsFetcher: QueryFunction<
    ProcessingChannelsResponseBody,
    UseProcessingChannelsQueryKey
  > = async ({ queryKey }): Promise<ProcessingChannelsResponseBody> => {
    const [path, { clientId, entityId }] = queryKey;

    const params: Params = {
      clientId,
    };
    if (entityId) {
      params.entityId = entityId;
    }

    const queryString = qs.stringify(params, {
      skipNull: true,
      sort: (a: string, b: string) => a.localeCompare(b),
    });
    const pathWithQueryString = `${path}?${queryString}`;
    const response = await fetch(pathWithQueryString);

    const data: ProcessingChannelsResponseBody = await response.json();

    return data;
  };

  return processingChannelsFetcher;
};
